import Dialog from "@components/dialog";
import BindingContext from "@odata/BindingContext";
import { AttendanceFormPage } from "@pages/payroll/payslip/overview/AttendanceFormPage";
import OverviewBase, { IOverviewBaseProps } from "@pages/payroll/payslip/overview/OverviewBase";
import { getAttendanceOverviewSections } from "@pages/payroll/payslip/Payslip.utils";
import memoizeOne from "@utils/memoizeOne";
import i18next from "i18next";
import React from "react";

interface IProps extends IOverviewBaseProps {
    bindingContext: BindingContext;
}

export default class AttendanceOverview extends OverviewBase<IProps> {
    _title = i18next.t("Payslip:Form.Attendance");
    _hasChangeAttendance = false;

    getSections = memoizeOne(() => {
        return getAttendanceOverviewSections(this.props.storage, this.props.bindingContext);
    }, () => ([this.props.storage.data.entity.Id, this.props.bindingContext.getFullPath()]));

    handleAttendanceChange = () => {
        this._hasChangeAttendance = true;
    }

    handleCloseDialog = (): void => {
        this.setState({ isEditDialogOpen: false });
        if (this._hasChangeAttendance) {
            // reload data to get new IDs
            this.props.storage.loadDataAfterSave();
        }
    };

    renderEditDialog(): React.ReactElement {
        return (
                <Dialog onClose={this.handleCloseDialog}
                        onConfirm={this.handleSave}
                        isEditableWindow>
                    <AttendanceFormPage rootStorage={this.props.storage}
                                        bindingContext={this.props.bindingContext}
                                        onAttendanceChange={this.handleAttendanceChange}
                                        onClose={this.handleCloseDialog} />
                </Dialog>
        );
    }
}
